import { PHIEU_IN_ENDPOINT, WF_TRACKER } from "../../../../utils/Constant";
import { TypeKeHoach } from "../models/KeHoachModel";

export const WMS_STATUS = {
  build_plan: "build_plan",
  directDownline: "directDownline",
  build_plan_approved: "build_plan_approved",
};

export const CODE_NHAP_KHO = {
  NHA_CUNG_CAP: 'X004',
  TRA_LE: 'X003',
  KHAC: 'X005',
  HOAN_TRA: 'X011',
}

export const TYPE_KE_HOACH: TypeKeHoach[] = [
  {
    name: 'Chuyển giao kỹ thuật',
    code: CODE_NHAP_KHO.NHA_CUNG_CAP,
    formThongTinChung: 'dohaquaylykehoach',
    formVatTu: 'dohaquaylykehoachkythuatchuyengiaokbcb',
    pathApi: '',
    pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
    trackerCode: WF_TRACKER.BUILD_PLAN_APPROVED_TECHNIQUE,
    termModelType: "directDownline"
  }
];

export const TYPE_KB_CB = {
  NOI_DUNG_CHUYEN_GIAO:
  {
    name: 'Nội dung chuyển giao',
    code: CODE_NHAP_KHO.NHA_CUNG_CAP,
    formThongTinChung: 'dohanoidungchuyengiao',
    formVatTu: '',
    pathApi: '',
    pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
    trackerCode: WF_TRACKER.SURVEY_TECHNIQUE_TRANFER_BATCH,
    termModelType: "directDownline"
  },
  BAO_CAO_KET_QUA:
  {
    name: 'Báo cáo kết quả hoạt động',
    code: CODE_NHAP_KHO.NHA_CUNG_CAP,
    formThongTinChung: 'dohacgktbaocaoketquahoatdong',
    formVatTu: '',
    pathApi: '',
    pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
    trackerCode: WF_TRACKER.BUILD_PLAN_APPROVED_TECHNIQUE,
    termModelType: "directDownline"
  },
  // QUA_TRINH_CHUYEN_GIAO:
  // {
  //   name: 'Nhân lực',
  //   code: CODE_NHAP_KHO.NHA_CUNG_CAP,
  //   formThongTinChung: 'dohanhanlucquatrinhchuyengiao',
  //   formVatTu: '',
  //   pathApi: '',
  //   pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
  //   trackerCode: WF_TRACKER.BUILD_PLAN,
  //   termModelType: "directDownline"
  // },
  NGHIEM_THU:
  {
    name: 'Nghiệm thu',
    code: CODE_NHAP_KHO.NHA_CUNG_CAP,
    formThongTinChung: 'dohanghiemthu',
    formVatTu: '',
    pathApi: '',
    pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
    trackerCode: WF_TRACKER.BUILD_PLAN_APPROVED_TECHNIQUE,
    termModelType: "directDownline"
  },
}

export const LEVEL_TYPE = {
  UPPER: "UPPER",
  LOWER: "LOWER",
}

export const STATUS: any = {
  1: { name: "Triển khai", code: 1 },
  2: { name: "Đào tạo lý thuyết", code: 2 },
  3: { name: "Đào tạo thực hành", code: 3 },
  4: { name: "Đánh giá ca bệnh", code: 4 },
  5: { name: "Hhỗ trợ từ xa", code: 5 },
  6: { name: "Hoàn thành", code: 6 },
  'pending_deployment': { name: "Chờ triển khai", code: 5 },
  'deployed': { name: "Hoàn thành", code: 6 },
}